import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';
import { CurrentUIState, uiState } from 'src/models/UIState';
import { CurrentUiStoreService } from 'src/app/services/ui/current-ui-store.service';
import { PdfStrokeColors } from 'src/app/core/pdf-utils/drawing-utils';
import { PdfStrokeColor } from 'src/app/core/pdf-utils/enums';
import { CustomTextareaService } from 'src/app/services/text-notes/custom-textarea.service';
import { TextNotesFontTypeStyle } from 'src/app/core/enums';
import { ICustomTextNoteElStyle, ITextNoteFont } from 'src/app/core/interfaces';
import { textNotesFontSizes, textNotesFonts } from 'src/app/core/common';
import { Subscription } from 'rxjs';
import { FloatingMenuComponent } from '../../floating-menu/floating-menu.component';
import { DocumentAnnotationService } from 'src/app/services/document/document-annotations.service';
import { ModalWindowService } from 'src/app/services/ui/modal-window.service';
import { YesNoDialogComponent } from '../../dialogs/yes-no-dialog/yes-no-dialog.component';
import { MainClickDirectiveDirective } from '../../../utils/directives/main-click-directive.directive';
import { TooltipDirective } from '../../../utils/directives/tooltip.directive';
import { NgClass, NgStyle } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'asg-toolbar-floating-menu',
    templateUrl: './toolbar-floating-menu.component.html',
    styleUrls: ['./toolbar-floating-menu.component.scss'],
    standalone: true,
    imports: [FloatingMenuComponent, MatDividerModule, TooltipDirective, MainClickDirectiveDirective, NgClass, NgStyle]
})
export class ToolbarFloatingMenuComponent implements OnInit, OnDestroy {
  @Input() uiState: CurrentUIState;
  @ViewChild(FloatingMenuComponent) floatingMenu: FloatingMenuComponent;

  private readonly subscriptions: Subscription = new Subscription();

  AsgardFeatureNames: typeof AsgardFeatureNames = AsgardFeatureNames;
  fontSizes: number[] = textNotesFontSizes;
  fonts: ITextNoteFont[] = textNotesFonts;
  fontTypes: typeof TextNotesFontTypeStyle = TextNotesFontTypeStyle;
  strokeColors: PdfStrokeColor[] = PdfStrokeColors.concat();
  style: ICustomTextNoteElStyle | null = null;

  get multiNoteCreationText(){
    return (this.uiState[AsgardFeatureNames.TEXT_NOTES].active && uiState[AsgardFeatureNames.NOTE_CREATION_MODE_MULTI].active);
  }

  get multiNoteCreationSticky(){
    return (this.uiState[AsgardFeatureNames.STICKY_NOTES].active && uiState[AsgardFeatureNames.NOTE_CREATION_MODE_MULTI].active);
  }

  constructor(
    private uiStore: CurrentUiStoreService,
    private area: CustomTextareaService,
    private annotService: DocumentAnnotationService,
    private modalService: ModalWindowService,
  ) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.initSubscriptions();
  }

  toggleFeatureState = (feature: AsgardFeatureNames) => {
    if (this.uiState[feature].active) {
      this.uiStore.setItemUnActive(feature);
    } else {
      this.uiStore.setItemActive(feature);
    }
  }

  close(): void {
    this.floatingMenu.close();
    this.floatingMenu.hide();
  }

  switchNotesMode = (notesFeature: AsgardFeatureNames.TEXT_NOTES | AsgardFeatureNames.STICKY_NOTES) => {
    if (!this.uiState[notesFeature].active) {
      this.uiStore.setItemActive([notesFeature, AsgardFeatureNames.NOTE_CREATION_MODE_SINGLE]);
      // this.uiStore.setItemActive(notesFeature);
      // this.area.creationMode = NoteCreationMode.SINGLE;
    // } else if (this.uiState[notesFeature].active && this.area.creationMode === NoteCreationMode.SINGLE) {
    } else if (this.uiState[notesFeature].active && this.uiState[AsgardFeatureNames.NOTE_CREATION_MODE_SINGLE].active) {
      // this.area.creationMode = NoteCreationMode.MULTI;
      // this.uiStore.setItemUnActive(AsgardFeatureNames.NOTE_CREATION_MODE_SINGLE);
      this.uiStore.setItemActive(AsgardFeatureNames.NOTE_CREATION_MODE_MULTI);

    } else {
      this.uiStore.setItemUnActive([notesFeature, AsgardFeatureNames.NOTE_CREATION_MODE_MULTI]);
      // this.area.creationMode = NoteCreationMode.SINGLE;
    }
  }

  selectFontSize = (e: number) => {
    this.area.selectFontSize(e);
  }

  selectColor = (e: PdfStrokeColor) => {
    this.area.selectColor(e);
  }

  selectFontType = (e: TextNotesFontTypeStyle) => {
    this.area.selectFontType(e);
  }

  selectFontFamily = (e: ITextNoteFont) => {
    this.area.selectFont(e);
  }

  deleteEmptyNotes = () => {
    const yesHandler = () => {
      const emptyTextNotes = this.annotService.getEmptyTextNotes();
      this.annotService.deleteAnnotations(emptyTextNotes);
    };

    this.modalService.createModalWindow(YesNoDialogComponent, { messageKey: 'COMMONMESSAGEDIALOG.DELETE_EMPTY_NOTES', yesHandler });
  }

  private initSubscriptions(): void {
    this.subscriptions.add(
      this.area.textAreaStyleStatus().subscribe(e => {
        this.style = e;
      })
    );
  }
}
